import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SHOULD_ATTACH_ACCESS_TOKEN } from '@digital-platform/rs-signup/services';
import { ProfileCountsResponse } from '@digital-platform/unified-wp-home/domain';

@Injectable({
  providedIn: 'root',
})
export class ProfileTrackService {
  constructor(private httpClient: HttpClient) {}

  public getProfilesCount(): Observable<ProfileCountsResponse> {
    const context = new HttpContext().set(SHOULD_ATTACH_ACCESS_TOKEN, true);
    const url = `api/uwp/comp/profiles/count`;

    return this.httpClient.get<ProfileCountsResponse>(url, { context });
  }
}
